import React from "react";
import { Skeleton } from "components/common/Skeleton";

/// A figure Paddle is still pricing. The zero-width space holds the figure's
/// line height, so nothing jumps when it lands.
export const Quoting: React.FC<{ width: string }> = ({ width }) => (
  <span className="flex items-center">
    {"​"}
    <Skeleton width={width} />
  </span>
);
